import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`HostJane is guided by the IHRA working definition of Antisemitism to identify Jew-hatred in user-generated material on our marketplace platform and managed servers.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      